import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import SiteFooter from '../components/SiteFooter'
import { contact, hero, processSteps, testimonialImage, testimonials, whyChoose } from '../content/siteContent'

function Home(){
    return(
        <Fragment>
            <div className="boxed_wrapper ltr">
                
                {/* <!-- Mobile Menu  --> */}
                <div className="mobile-menu">
                    <div className="menu-backdrop"></div>
                    <div className="close-btn"><i className="fas fa-times"></i></div>            
                    <nav className="menu-box">
                        <div className="nav-logo"><Link to="/"><img src="assets/images/logo-4.png" alt="H.J. Enterprises" title=""/></Link></div>
                        <div className="menu-outer">
                            {/* <!--Here Menu Will Come Automatically Via Javascript / Same Menu as in Header--> */}
                        </div>             
                    </nav>
                </div>
                {/* <!-- End Mobile Menu --> */}


                {/* <!-- banner-style-three --> */}
                <section className="banner-style-three p_relative">
                    <div className="shape" style={{backgroundImage: 'url(assets/images/shape/shape-19.png)'}}></div>
                    <div className="banner-carousel owl-theme owl-carousel owl-dots-none owl-nav-none">
                        <div className="slide-item p_relative">
                            <div className="bg-layer" style={{backgroundImage: 'url(assets/images/banner/banner-7.jpg)'}}></div>
                            <div className="pattern-layer">
                                <div className="pattern-4" style={{backgroundImage: 'url(assets/images/shape/shape-14.png)'}}></div>
                                <div className="pattern-5" style={{backgroundImage: 'url(assets/images/shape/shape-15.png)'}}></div>
                            </div>
                            <div className="auto-container">
                                <div className="content-box">
                                    <h2>{hero.partner}</h2>
                                    <p>{hero.tagline}</p>
                                </div> 
                            </div>
                        </div>
                        <div className="slide-item p_relative">
                            <div className="bg-layer" style={{backgroundImage: 'url(assets/images/banner/banner-8.jpg)'}}></div>
                            <div className="pattern-layer">
                                <div className="pattern-4" style={{backgroundImage: 'url(assets/images/shape/shape-14.png)'}}></div>
                                <div className="pattern-5" style={{backgroundImage: 'url(assets/images/shape/shape-15.png)'}}></div>
                            </div>
                            <div className="auto-container">
                                <div className="content-box">
                                    <h2>{hero.guidance}</h2>
                                </div> 
                            </div>
                        </div>
                        <div className="slide-item p_relative">
                            <div className="bg-layer" style={{backgroundImage: 'url(assets/images/banner/banner-9.jpg)'}}></div>
                            <div className="pattern-layer">
                                <div className="pattern-4" style={{backgroundImage: 'url(assets/images/shape/shape-14.png)'}}></div>
                                <div className="pattern-5" style={{backgroundImage: 'url(assets/images/shape/shape-15.png)'}}></div>
                            </div>
                            <div className="auto-container">
                                <div className="content-box">
                                    <h2>{hero.closer}</h2>
                                    <p>{hero.callLabel}</p>
                                    <div className="btn-box">
                                        <a href={contact.phoneTel} className="theme-btn btn-three">Call Us</a>
                                    </div>
                                </div>  
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- banner-style-three end --> */}

                {/* <!-- about-section --> */}
                <section className="about-section pt_120 pb_120">
                    <div className="pattern-layer rotate-me"></div>
                    <div className="auto-container">
                        <div className="row clearfix">
                            <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                                <div className="image_block_one">
                                    <div className="image-box pr_90 mr_40">
                                        <div className="image-shape" style={{backgroundImage: 'url(assets/images/shape/shape-3.png)'}}></div>
                                        <figure className="image"><img src="assets/images/site/hero-dream-home.jpg" alt="H.J. Enterprises"/></figure>                               
                                        <div className="experience-box">
                                            <div className="inner">
                                                <h6>{contact.location}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                                <div className="content_block_one">
                                    <div className="content-box ml_40">
                                        <div className="sec-title mb_20">                                   
                                            <h2>{hero.brand}</h2>
                                        </div>
                                        <div className="text-box mb_40">
                                            <p>{hero.intro}</p>
                                            <p>{hero.introDetail}</p>
                                        </div>
                                        <div className="inner-box mb_45">
                                            <div className="single-item">
                                                <div className="icon-box"><i className="icon-10"></i></div>
                                                <h3>{whyChoose[0].title}</h3>
                                                <p>{whyChoose[0].text}</p>
                                            </div>
                                            <div className="single-item">
                                                <div className="icon-box"><i className="icon-11"></i></div>
                                                <h3>{whyChoose[3].title}</h3>
                                                <p>{whyChoose[3].text}</p>
                                            </div>
                                        </div>
                                        <div className="btn-box">
                                            <Link to="/aboutus" className="theme-btn btn-one">Read More</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- about-section end --> */}

                {/* <!-- feature-section --> */}
                <section className="feature-section">
                    <div className="auto-container">
                        <div className="inner-container clearfix wow fadeInLeft animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                            <div className="feature-block-one">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="icon-5"></i></div>
                                    <h4><Link to="/loan">Loan</Link></h4>
                                    <p>Home loans, loan against property, personal, business, vehicle, startup and builder project finance.</p>
                                </div>
                            </div>
                            <div className="feature-block-one">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="icon-6"></i></div>
                                    <h4><Link to="/insurance">Insurance</Link></h4>
                                    <p>Life, health, motor, property and other eligible insurance solutions on one platform.</p>
                                </div>
                            </div>
                            <div className="feature-block-one">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="icon-7"></i></div>
                                    <h4><Link to="/mutualfund">Mutual Fund</Link></h4>
                                    <p>Explore investment options with guidance on products that may suit your requirement.</p>
                                </div>
                            </div>
                            <div className="feature-block-one">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="icon-8"></i></div>
                                    <h4><Link to="/realestate">Real Estate</Link></h4>
                                    <p>Property-related finance assistance for residential and commercial requirements.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- feature-section end --> */}


                {/* <!-- service-style-three --> */}
                <section className="service-style-three service-page-2 pt_50 pb_50">		 
                    <div className="auto-container">
                        <div className="sec-title centred mb_60">                    
                            <h2>Why Choose H.J. Enterprises?</h2>
                        </div>
                        <div className="row clearfix">
                            <div className="col-lg-4 col-md-6 col-sm-12 service-block">
                                <div className="service-block-one wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                                    <figure className="image-box"><a href="service-details.html"><img src="assets/images/service/service-5.jpg" alt=""/></a></figure>
                                    <div className="inner-box">
                                        <div className="icon-box"><i className="icon-12"></i></div>
                                        <h4><Link to="/loan">{whyChoose[0].title}</Link></h4>
                                        <ul className="list-item clearfix">
                                            <li>{whyChoose[0].text}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 service-block">
                                <div className="service-block-one wow fadeInUp animated" data-wow-delay="300ms" data-wow-duration="1500ms">
                                    <figure className="image-box"><a href="service-details-2.html"><img src="assets/images/site/why-business-services.jpg" alt="Multiple Financial Solutions" style={{ objectPosition: 'center 42%' }}/></a></figure>
                                    <div className="inner-box">
                                        <div className="icon-box"><i className="icon-13"></i></div>
                                        <h4><Link to="/loan">{whyChoose[1].title}</Link></h4>
                                        <ul className="list-item clearfix">
                                            <li>{whyChoose[1].text}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 service-block">
                                <div className="service-block-one wow fadeInUp animated" data-wow-delay="600ms" data-wow-duration="1500ms">
                                    <figure className="image-box"><a href="service-details-3.html"><img src="assets/images/service/service-7.jpg" alt=""/></a></figure>
                                    <div className="inner-box">
                                        <div className="icon-box"><i className="icon-14"></i></div>
                                        <h4><Link to="/contactus">{whyChoose[2].title}</Link></h4>
                                        <ul className="list-item clearfix">
                                            <li>{whyChoose[2].text}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 service-block">
                                <div className="service-block-one wow fadeInUp animated" data-wow-delay="900ms" data-wow-duration="1500ms">
                                    <figure className="image-box"><a href="service-details-4.html"><img src="assets/images/site/hero-growth.jpg" alt="Transparent Process" style={{ objectPosition: 'center 72%' }}/></a></figure>
                                    <div className="inner-box">
                                        <div className="icon-box"><i className="icon-15"></i></div>
                                        <h4><Link to="/aboutus">{whyChoose[3].title}</Link></h4>
                                        <ul className="list-item clearfix">
                                            <li>{whyChoose[3].text}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 service-block">
                                <div className="service-block-one wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                                    <figure className="image-box"><a href="service-details-5.html"><img src="assets/images/service/service-9.jpg" alt=""/></a></figure>
                                    <div className="inner-box">
                                        <div className="icon-box"><i className="icon-16"></i></div>
                                        <h4><Link to="/aboutus">{whyChoose[4].title}</Link></h4>
                                        <ul className="list-item clearfix">
                                            <li>{whyChoose[4].text}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 service-block">
                                <div className="service-block-one wow fadeInUp animated" data-wow-delay="300ms" data-wow-duration="1500ms">
                                    <figure className="image-box"><a href="service-details-6.html"><img src="assets/images/service/service-10.jpg" alt=""/></a></figure>
                                    <div className="inner-box">
                                        <div className="icon-box"><i className="icon-17"></i></div>
                                        <h4><Link to="/insurance">Insurance Solutions</Link></h4>
                                        <ul className="list-item clearfix">
                                            <li>Life, Health, Motor and Property insurance assistance.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </section>
                {/* <!-- service-style-three end --> */}

                {/* <!-- process-section --> */}
                <section className="process-section centred pt_60 pb_90">
                    <div className="bg-layer" style={{backgroundImage: 'url(assets/images/background/process-bg.jpg)'}}></div>
                    <div className="auto-container">
                        <div className="sec-title mb_110">                   
                            <h2>Our Process</h2>
                        </div>
                        <div className="inner-container">
                            {processSteps.map((step) => (
                                <div className="processing-block-one" key={step.step}>
                                    <div className="inner-box">
                                        <span className="count-text">{step.step} <br/>Step</span>
                                        <h3>{step.title}</h3>
                                        <p>{step.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
                {/* <!-- process-sectione end --> */}

                {/* <!-- funfact-style-two --> */}
                <section className="funfact-style-two">
                    <div className="bg-layer" style={{backgroundImage: 'url(assets/images/background/funfact-bg.jpg)'}}></div>
                    <div className="auto-container">
                        <div className="row clearfix">
                            <div className="col-lg-6 col-md-6 col-sm-12 funfact-block">
                                <div className="funfact-block-one">
                                    <div className="inner-box">
                                        <div className="icon-box"><i className="icon-21"></i></div>
                                        <div className="count-outer count-box">
                                            <span className="count-text" data-speed="1500" data-stop="4">0</span><span>k+</span>
                                        </div>
                                        <p>Happy Clients</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 funfact-block">
                                <div className="funfact-block-one">
                                    <div className="inner-box">
                                        <div className="icon-box"><i className="icon-22"></i></div>
                                        <div className="count-outer count-box">
                                            <span className="count-text" data-speed="1500" data-stop="6">0</span><span>k+</span>
                                        </div>
                                        <p>Total Transactions</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- funfact-style-two end --> */}

                {/* <!-- testimonial-section --> */}
                <section className="testimonial-section centred pt_60 pb_120" id="testimonial">
                    <div className="bg-layer" style={{backgroundImage: 'url(assets/images/background/testimonial-bg.jpg)'}}></div>
                    <div className="auto-container">
                        <div className="sec-title mb_70">
                            
                            <h2>Testimonials</h2>
                        </div>
                        <div className="three-item-carousel owl-carousel owl-theme owl-dots-none owl-nav-none">
                            {testimonials.map((item) => (
                                <div className="testimonial-block-one" key={item.id}>
                                    <div className="inner-box">
                                        <figure className="thumb-box">
                                            <img src={testimonialImage} alt="" />
                                        </figure>
                                        <h4>{item.name}</h4>
                                        <span className="designation">{item.designation}</span>
                                        <ul className="rating mb_6 clearfix">
                                            <li><i className="icon-26"></i></li>
                                            <li><i className="icon-26"></i></li>
                                            <li><i className="icon-26"></i></li>
                                            <li><i className="icon-26"></i></li>
                                            <li><i className="icon-26"></i></li>
                                        </ul>
                                        <p>“{item.quote}”</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
                {/* <!-- testimonial-section end --> */}


                {/* <!-- main-footer --> */}
                <SiteFooter />
                {/* <!-- main-footer end --> */}



                {/* <!--Scroll to top--> */}
                <div className="scroll-to-top">
                    <div>
                        <div className="scroll-top-inner">
                            <div className="scroll-bar">
                                <div className="bar-inner"></div>
                            </div>
                            <div className="scroll-bar-text">Go To Top</div>
                        </div>
                    </div>
                </div>
                {/* <!-- Scroll to top end --> */}

            </div>
        </Fragment>
    )
}

export default Home;